<template>
  <div class="container-fluid py-3">
    <form class="needs-validation" @submit.prevent>
      <div class="row">

        <!-- Левая секция: Существующие перемещения -->
        <div class="col-6 border-right">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="text-dark font-weight-bold mb-0">Существующие перемещения</h5>
            <button
                type="button"
                class="btn btn-danger btn-sm"
                @click="deleteLastMovement"
                :disabled="geoMovementsData.length === 0 || isLoading"
            >
              Удалить последнее перемещение
            </button>
          </div>

          <div class="border rounded p-3 bg-white shadow-sm h-100">
            <div class="row font-weight-bold text-muted border-bottom pb-2 mb-2">
              <div class="col-1">ID</div>
              <div class="col-2">Дата</div>
              <div class="col-2">Кол-во</div>
              <div class="col-3">С Объекта</div>
              <div class="col-4">На Объект</div>
            </div>

            <div v-if="geoMovementsData.length > 0">
              <div
                  v-for="item in geoMovementsData"
                  :key="'mov-' + item.id"
                  class="row py-2 align-items-center border-bottom text-break"
              >
                <div class="col-1 font-weight-bold">{{ item.id }}</div>
                <div class="col-2 small text-secondary">{{ item.operation_date }}</div>
                <div class="col-2">{{ item.value }}</div>

                <div class="col-3">
                  {{ item.donorLocation ? item.donorLocation.name : '—' }}
                  <small v-if="item.donorLocation && item.donorLocation.id" class="text-muted d-block">
                    (id={{ item.donorLocation.id }})
                  </small>
                </div>
                <div class="col-4">
                  {{ item.acceptorLocation ? item.acceptorLocation.name : '—' }}
                  <small v-if="item.acceptorLocation && item.acceptorLocation.id" class="text-muted d-block">
                    (id={{ item.acceptorLocation.id }})
                  </small>
                </div>
              </div>
            </div>
            <div v-else class="text-center text-muted py-3">
              Перемещения отсутствуют
            </div>
          </div>
        </div>

        <!-- Правая секция: Поиск и Адреса -->
        <div class="col-6">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="text-dark font-weight-bold mb-0">На какой объект переместить?</h5>
            <button
                type="button"
                class="btn btn-success btn-sm"
                @click="createObject"
            >
              Создать объект
            </button>
          </div>

          <div class="border rounded p-3 bg-white shadow-sm h-100">
            <div class="form-group mb-3">
              <input
                  v-model="searchString"
                  type="text"
                  :placeholder="$t ? $t('navbar.search.text') : 'Поиск...'"
                  class="form-control form-control-sm"
              >
            </div>

            <!-- ИСПРАВЛЕНО: Добавлен заголовок "Название", перераспределена сетка на 12 колонок -->
            <div class="row font-weight-bold text-muted border-bottom pb-2 mb-2">
              <div class="col-1">ID</div>
              <div class="col-4">Название</div>
              <div class="col-7">Адрес</div>
            </div>

            <!-- Данные адресов (Строки) -->
            <div v-if="filteredGeoLocations.length > 0">
              <div
                  v-for="item in filteredGeoLocations"
                  :key="'loc-' + item.id"
                  class="row py-2 align-items-center border-bottom text-break clickable-row"
                  @click="selectLocationForMove(item)"
              >
                <!-- ИСПРАВЛЕНО: Вывод полей по новой структуре колонок -->
                <div class="col-1 font-weight-bold">{{ item.id }}</div>
                <div class="col-4 text-secondary">{{ item.name || '—' }}</div>
                <div class="col-7">{{ item.title }}</div>
              </div>
            </div>
            <div v-else class="text-center text-muted py-3">
              Ничего не найдено
            </div>
          </div>
        </div>

      </div>
    </form>

    <!-- Модалка 1: Создание нового объекта -->
    <geo-location-create-modal
        :is-open="isCreateModalOpen"
        @close="isCreateModalOpen = false"
        @created="onLocationCreated"
    />

    <!-- Модалка 2: Оформление перемещения -->
    <unit-geo-move-modal
        :is-open="isMoveModalOpen"
        :unit-id="currentUnitId"
        :location-id="selectedLocation.id"
        :location-title="selectedLocation.title"
        @close="isMoveModalOpen = false"
        @moved="onUnitMoved"
    />
  </div>
</template>


<script>
import axios from "axios";
import GeoLocationCreateModal from "./GeoLocationCreateModal.vue";
import UnitGeoMoveModal from "./UnitGeoMoveModal.vue";

export default {
  name: "unit-geo-movements",
  components: {
    GeoLocationCreateModal,
    UnitGeoMoveModal
  },
  data() {
    return {
      searchString: '',
      isLoading: false,
      isCreateModalOpen: false,
      isMoveModalOpen: false,
      currentUnitId: null,
      selectedLocation: { id: null, title: '' },
      geoLocationsData: [],
      geoMovementsData: []
    }
  },
  computed: {
    filteredGeoLocations() {
      if (!this.searchString) {
        return this.geoLocationsData;
      }
      const search = this.searchString.toLowerCase().trim();
      return this.geoLocationsData.filter(item => {
        // ИСПРАВЛЕНО: Теперь живой поиск ищет совпадения И по адресу (title), И по названию (name)
        const titleMatch = item.title && item.title.toLowerCase().includes(search);
        const nameMatch = item.name && item.name.toLowerCase().includes(search);
        return titleMatch || nameMatch;
      });
    }
  },
  mounted() {
    this.getGeoLocationsData();
  },
  methods: {
    getGeoLocationsData() {
      this.isLoading = true;
      let uri = `/v1/geo-locations/get-all-simple`;
      axios
          .get(uri)
          .then(resp => {
            this.geoLocationsData = resp.data || [];
          })
          .catch(err => {
            const errorMsg = err.response && err.response.data && err.response.data.message
                ? err.response.data.message : "Не удалось загрузить список объектов";
            if (this.$store) {
              this.$store.dispatch("addNotification", { text: errorMsg, time: 6, color: "danger" });
            }
          })
          .finally(() => { this.isLoading = false; });
    },

    getGeoMovementsData(unitId) {
      this.currentUnitId = unitId;
      this.isLoading = true;
      let uri = `/v1/units/get-geo-movements-with-actors`;
      axios
          .get(uri, { params: { id: unitId } })
          .then(resp => { this.geoMovementsData = resp.data || []; })
          .catch(err => {
            const errorMsg = err.response && err.response.data && err.response.data.message
                ? err.response.data.message : "Ошибка запроса";
            if (this.$store) {
              this.$store.dispatch("addNotification", { text: errorMsg, time: 6, color: "danger" });
            }
          })
          .finally(() => { this.isLoading = false; });
    },

    createObject() {
      this.isCreateModalOpen = true;
    },

    onLocationCreated(newLocation) {
      // ИСПРАВЛЕНО: При получении объекта из модалки сохраняем и адрес, и оригинальное поле name
      const formattedLocation = {
        id: newLocation.id,
        name: newLocation.name,
        title: newLocation.title || newLocation.address || newLocation.name
      };
      this.geoLocationsData.unshift(formattedLocation);
    },

    selectLocationForMove(location) {
      if (!this.currentUnitId) {
        if (this.$store) {
          this.$store.dispatch("addNotification", { text: "ID мат. единицы не определен", time: 4, color: "warning" });
        }
        return;
      }
      this.selectedLocation = { id: location.id, title: location.title };
      this.isMoveModalOpen = true;
    },

    // ИСПРАВЛЕНО: Чистая сигнатура без аргументов для обновления с бэкенда по первому пути
    onUnitMoved() {
      this.getGeoMovementsData(this.currentUnitId);
      this.$emit("unit-geo-moved");
    },

    deleteLastMovement() {
      if (this.geoMovementsData.length === 0 || !this.currentUnitId) {
        return;
      }

      if (confirm("Вы уверены, что хотите безвозвратно удалить последнее перемещение?")) {
        this.isLoading = true;
        let uri = `/v1/units/delete-last-geo-movement`;

        axios
            .post(uri, { unit_id: this.currentUnitId })
            .then(resp => {
              this.geoMovementsData.shift();
              if (this.$store) {
                this.$store.dispatch("addNotification", { text: resp.data.message || "Перемещение удалено", time: 4, color: "success" });
              }
            })
            .catch(err => {
              const errorMsg = err.response && err.response.data && err.response.data.message
                  ? err.response.data.message : "Не удалось удалить перемещение";
              if (this.$store) {
                this.$store.dispatch("addNotification", { text: errorMsg, time: 6, color: "danger" });
              }
            })
            .finally(() => { this.isLoading = false; });
      }
    }
  },
}
</script>

<style scoped lang="scss">
caption {
  caption-side: top !important;
}

.clickable-row {
  cursor: pointer;
  transition: background-color 0.15s ease-in-out;

  &:hover {
    background-color: #f1f3f5 !important;
  }
}
</style>
